import { SearchBox } from 'react-instantsearch'

export default function FilterSearchBox() {
  return (
    <SearchBox
      className="w-full"
      submitIconComponent={() => null}
      resetIconComponent={() => null}
      placeholder="Search"
      classNames={{
        submit: 'hidden',
        resetIcon: 'hidden',
        loadingIndicator: 'hidden',
        input: 'icon-left border focus:border-2 focus:!border-gradient shadow-none ',
      }}
    />
  )
}
